import firebase from 'firebase';

firebase.initializeApp({
    apiKey: "AIzaSyDk7OH8oayDWDelCN16tj0us-i0LdUN2js",
    authDomain: "iphco-59d8b.firebaseapp.com",
    projectId: "iphco-59d8b",
    storageBucket: "iphco-59d8b.appspot.com",
    messagingSenderId: "257554334522",
    appId: "1:257554334522:web:e205daf61c3f2482124603",
    measurementId: "G-SCHCJ92X07"
});

export default firebase;